import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import { startStorageUpdateListener } from './localdb/storageUpdate';
import { fetchAppConfig } from './appConfig';
import './styles.css';

startStorageUpdateListener();
void fetchAppConfig();
createApp(App).use(router).mount('#app');
